<template>
  <div id="faq" class="faq">
    <Header />

    <div id="header-navi" class="header-navi">
      <h2 class="header-navi__ttl">FAQ</h2>
    </div>

    <div class="faq__main">
      <dl v-for="(faq, index) in faqList" :key="index" class="is-hide">
        <dt @click="toggleBlock">{{ faq.q }}</dt>
        <dd>{{ faq.a }}</dd>
      </dl>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: {
    Header,
    Footer
  },
  data () {
    return {
      faqList: [
        {
          q: 'カスタマイズ商品の発送日数について教えてください。',
          a: '各商品、カスタマイズされた内容によって異なります。オーダー品になりますので、お時間を頂戴いたしますことをご了承ください。'
        },
        {
          q: '返品・交換・カスタマイズ内容の変更はできますか？',
          a: 'カスタマイズされた商品の返品・交換・カスタマイズ内容の変更は受けておりません。ご了承ください。ご利用のパソコンや環境によって、商品・ワッペン・刺繍の色やサイズが実際の商品と異なって見える場合がございます。また、ワッペンや刺繍の取り付け位置が上下左右に若干ぶれることがございます。あらかじめご理解の上、お買い求めください。'
        },
        {
          q: '刺繍は何文字まで入れられますか？',
          a: 'バッグの仕様やお入れする文字により上限が異なります。'
        },
        {
          q: '手持ちの商品にカスタマイズすることはできますか？',
          a: 'カスタマイズは当サイトにて商品ご購入と同時に承っております。お手持ちの商品や別サイトでご購入された商品のカスタマイズは承れません。'
        }
      ]
    }
  },
  methods: {
    toggleBlock (e) {
      if (e.currentTarget.parentNode.className === 'is-hide') {
        e.currentTarget.parentNode.className = 'is-show'
        return false
      }
      if (e.currentTarget.parentNode.className === 'is-show') {
        e.currentTarget.parentNode.className = 'is-hide'
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-navi {
  @include customTitle;
}

.faq {
  &__main {
    min-height: 55vh;
    margin: 20px 0;
    dl {
      padding: 20px 15px;
      line-height: 1.4;
      border-bottom: 1px solid $right-gray;
      dt {
        font-size: 15px;
        padding: 0 40px 0 0;
        font-weight: bold;
        position: relative;
      }
      dd {
        font-size: 14px;
        overflow: hidden;
      }
      &.is-hide {
        dt {
          &::after {
            content: '＋';
            font-size: 20px;
            line-height: 1.0;
            position: absolute;
            top: 50%;
            right: 0;
            margin-top: -11px;
          }
        }
        dd {
          height: 0;
          padding: 0;
          transition: all 0.5s ease;
        }
      }
      &.is-show {
        dt {
          &::after {
            content: 'ー';
            font-size: 20px;
            line-height: 1.0;
            position: absolute;
            top: 50%;
            right: 0;
            margin-top: -11px;
          }
        }
        dd {
          height: auto;
          padding: 15px 0 0 0;
          transition: all 0.5s ease;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Faq.vue